import { TextField } from '@mui/material';
import styled from 'styled-components';

import CommonComponentStyle from 'commons/styles/basic-components.styles';

import { DELIVERY_NOTE_LIST_MOBILE_BREAKPOINT } from './DNListPage.constants';

class DNListPageStyles extends CommonComponentStyle {
  PageWrapper = styled.div`
    padding: 16px 12px 0 12px;
  `;

  TableWrapper = styled.div`
    overflow-y: auto;
    overflow-x: auto;
    max-height: calc(100vh - 200px);
  `;

  FilterRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 0 8px 0;
    width: 100%;
    flex-wrap: wrap;
  `;

  SearchField = styled(TextField)`
    flex: 1;
    min-width: 0;
  `;

  RefreshButton = styled(this.SecondaryButton)`
    width: auto !important;
    white-space: nowrap;
    padding: 6px 16px !important;
    @media (max-width: ${DELIVERY_NOTE_LIST_MOBILE_BREAKPOINT}px) {
      font-size: 12px !important;
    }
  `;

  DetailsButton = styled(this.SecondaryButton)`
    width: auto !important;
    @media (max-width: ${DELIVERY_NOTE_LIST_MOBILE_BREAKPOINT}px) {
      width: 32px !important;
      min-width: 32px !important;
      height: 32px !important;
      padding: 0 !important;
    }
  `;

  DetailsButtonLabel = styled.span`
    @media (max-width: ${DELIVERY_NOTE_LIST_MOBILE_BREAKPOINT}px) {
      display: none;
    }
  `;

  DetailsButtonIcon = styled.span`
    display: none;
    line-height: 0;
    @media (max-width: ${DELIVERY_NOTE_LIST_MOBILE_BREAKPOINT}px) {
      display: flex;
      align-items: center;
    }
  `;

  StyledTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-top: 8px;
  `;

  TableHeaderCell = styled.th`
    padding: 10px 4px;
    text-align: left;
    font-weight: 600;
    font-size: 14px;
    border-bottom: 1px solid ${this.colors.LIGHT_GRAY};
    overflow-wrap: break-word;
    hyphens: auto;
    position: sticky;
    top: 0;
    background: white;
    z-index: 1;
    @media (max-width: ${DELIVERY_NOTE_LIST_MOBILE_BREAKPOINT}px) {
      font-size: 12px;
    }
  `;

  DataRow = styled.tr`
    border-bottom: 1px solid ${this.colors.LIGHT_GRAY};
    &:last-child {
      border-bottom: none;
    }
  `;

  DataCell = styled.td`
    padding: 10px 4px;
    font-size: 14px;
    word-break: break-word;
    @media (max-width: ${DELIVERY_NOTE_LIST_MOBILE_BREAKPOINT}px) {
      font-size: 12px;
    }
  `;

  NoDataCell = styled(this.DataCell)`
    padding-top: 18px;
  `;

  PaginationRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0;
    border-top: 1px solid ${this.colors.LIGHT_GRAY};
    width: 100%;
  `;

  PaginationText = styled.span`
    font-size: 14px;
    color: ${this.colors.PRIMARY_GRAY};
    @media (max-width: ${DELIVERY_NOTE_LIST_MOBILE_BREAKPOINT}px) {
      font-size: 12px;
    }
  `;

  PaginationControls = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
  `;

  PageNumber = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    font-size: 14px;
    color: ${this.colors.PRIMARY_GRAY};
  `;

  PaginationButton = styled(this.SecondaryButton)`
    width: auto !important;
    min-width: 32px !important;
    padding: 4px !important;
    @media (max-width: ${DELIVERY_NOTE_LIST_MOBILE_BREAKPOINT}px) {
      font-size: 12px !important;
    }
  `;

  StatusBadge = styled.span<{ $bg: string; $color: string }>`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.3px;
    white-space: nowrap;
    background-color: ${({ $bg }) => $bg};
    color: ${({ $color }) => $color};
    @media (max-width: ${DELIVERY_NOTE_LIST_MOBILE_BREAKPOINT}px) {
      font-size: 10px;
      padding: 2px 6px;
    }
  `;
}

const S = new DNListPageStyles();

export default S;
